import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ElementRef, Injectable } from '@angular/core';
import { TooltipOverlayComponent } from './tooltip-overlay.component';
import { TOOLTIP_CONTENT, TooltipContent } from './tooltip.data';

@Injectable({ providedIn: 'root' })
export class TooltipService {
  private overlayRef: OverlayRef | null = null;

  constructor(private overlay: Overlay) {}

  toggleByKey(origin: ElementRef<HTMLElement> | HTMLElement, key: string): void {
    if (this.overlayRef) {
      this.close();
      return;
    }

    this.openByKey(origin, key);
  }

  openByKey(origin: ElementRef<HTMLElement> | HTMLElement, key: string): void {
    const group = key.split('.')[0];
    const contentKey = key.split('.')[1];
    const content = TOOLTIP_CONTENT[group][contentKey];

    if (!content) {
      this.close();
      return;
    }

    this.open(origin, content);
  }

  close(): void {
    if (!this.overlayRef) {
      return;
    }

    this.overlayRef.dispose();
    this.overlayRef = null;
  }

  private open(origin: ElementRef<HTMLElement> | HTMLElement, content: TooltipContent): void {
    this.close();

    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(origin)
      .withPositions([
        {
          originX: 'center',
          originY: 'bottom',
          overlayX: 'center',
          overlayY: 'top',
          offsetY: 8,
        },
        {
          originX: 'end',
          originY: 'center',
          overlayX: 'start',
          overlayY: 'center',
          offsetX: 8,
        },
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom',
          offsetY: -8,
        },
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      disposeOnNavigation: true,
    });

    const portal = new ComponentPortal<TooltipOverlayComponent>(TooltipOverlayComponent);
    const componentRef = this.overlayRef.attach(portal);

    componentRef.instance.content = content;

    this.overlayRef.backdropClick().subscribe(() => this.close());
    this.overlayRef.keydownEvents().subscribe((event) => event.key === 'Escape' && this.close());
  }
}
